export enum BotSettingsFormFieldsNames {
  Token = 'token',
}
export interface BotSettingsFormFields {
  [BotSettingsFormFieldsNames.Token]: string;
}
